<template lang="html">

  <section class="contenedor-tabla" :style="styles.colorBasic">

    <div class="contenedor-opciones row-between">

      <h2 class="ficha-title" :style="styles.colorBasic">Listado de prácticas</h2>

      <div class="row-end">

        <a class="option-table column-center" v-if="!!dataSelected && dataSelected.length != 0">
          <i class="column row-between ais" @click="exportExcel"><excel></excel></i>
          <span @click="exportExcel">Descargar</span>
        </a>
        
        <a class="option-table column-center" >
          <i class="column row-between ais" @click="showColumnasSetter = !showColumnasSetter"><columnas></columnas></i>
          <span @click="showColumnasSetter = !showColumnasSetter">Columnas</span>
          <column-setter v-if="showColumnasSetter" :columns="encabezados" @change="setColumnas" @cerrar="showColumnasSetter = false"></column-setter>
        </a>
        
        
      </div>

    </div>  

    <div class="scroll-table" >

      <div class="contenedor-tabla" :type="$route.name" v-if="!!dataSelected">


        <template v-if="dataSelected.length > 0">

          <v-client-table 
          :data="dataSelected" 
          :columns="columns" 
          :options="options"
          @row-click='open'
          >
          <span class="checkbox-cell row-start" slot="checkbox" slot-scope="{ row }">
  
            <figure class="indicador-status" :status="row.idEstadoValidacion" :title="row.estadoValidacion"></figure>

            <template v-if="!!row">
              <fav :data="row"></fav>
            </template>

          </span>

          <span class="action-cell row-start" slot="actions" slot-scope="{ row }"> 
            <router-link :to="linkBack+row.idPractica" class="to-ficha">
              <next></next>
            </router-link>
          </span>
        </v-client-table>
      </template>

      <template v-else>
        NO HAY DATOS
      </template>

    </div>

  </div>

</section>

</template>

<script lang="js">

  import {ClientTable, Event} from 'vue-tables-2';

  import Vue from 'vue';

  Vue.use(ClientTable);

  import daterangepicker from 'daterangepicker';

  window.moment = require('moment');

  import router from '@/router';

  import {mapGetters, mapActions} from 'vuex';

  import columnSetter from '@/components/parts/column-setter';

  import next  from '@/components/parts/icons/next';
  import excel  from '@/components/parts/icons/excel';
  import columnas  from '@/components/parts/icons/columnas';

  import fav  from '@/components/parts/fav';



  import XLSX from 'xlsx';

  export default  {
    name: 'contenedor-tabla',
    props: [],
    mounted(){
      this.setColumnas();
    },
    methods:{
      setColumnas(){

        let alwaysActive = ['actions','checkbox'];


        this.encabezados = this.getEncabezados[this.$route.name];

        // /SETTING DE LOS NOMBRE DE LAS COLUMNAS
        let columnas = (!!this.encabezados) ?  Object.entries(this.encabezados) : [];

        let visibles = new Object();

        this.columns = ['checkbox'];

        columnas.forEach(e =>{
          if(e[1].visible){
            visibles[e[0]] = e[1].nombre;
            this.columns.push(e[0])
            this.options.columnsClasses[e[0]] = '-'+e[0]
          }
        });

        alwaysActive.forEach(e=>{
          visibles[e] = '';
        })

        this.columns.push('actions');

        this.options.headings = visibles;
      },
      toggleAllChecks : function(){
        if(this.selected.length > 0){
          this.selected ={};
        }

      },
      open : function({row}){

        if(event.target.tagName == "TD"){
          if(!this.linkBack.includes("undefined")){
            router.push(this.linkBack+row.idPractica)  
          }else{
            router.push(`${this.$route.meta.indexPath}/${row.idPractica}`);
          }
        }
      },
      exportExcel() {
        let data = XLSX.utils.json_to_sheet(this.listadopracticas);
        const workbook = XLSX.utils.book_new();
        const date = new Date();
        const filename = String(`${date.getDay()}-${date.getMonth() + 1}-${date.getFullYear()} - Listado prácticas`);
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      },
      ...mapActions(['toggleFavoritos'])
    },
    computed: {
      ...mapGetters({
        styles : 'getStyles',
        colors : 'basicColors',
        validaciones : 'getValidaciones',
        validacionesPorEstados : 'getValidacionesPorEstados',
        tutoradas : 'getTutoradas',
        tutoradasPorEstados : 'getTutoradasPorEstados',
        asignaciones : 'getAsignaciones',
        asignacionesPorEstados : 'getAsignacionesPorEstados',
        favoritos : 'getFavoritos',
        getEncabezados : 'getEncabezados',
        textos : 'getTexts'
      }),
      linkBack : function(){
        return `${this.$route.meta.indexPath}/${(!Number(this.$route.params.status) > 0) ? this.$route.params.status : undefined}/`;
      },
      dataSelected : function(){

        let selected = new Array();

        if(!Number(this.$route.params.status) > 0){
          if(this.$route.name == 'validaciones'){
            selected = (!!this.$route.params.status) ? this.validacionesPorEstados[this.$route.params.status] : this.validaciones;
          }else if (this.$route.name == 'tutorados'){
            selected = (!!this.$route.params.status) ? this.tutoradasPorEstados[this.$route.params.status] : this.tutoradas;
          }else if (this.$route.name == 'asignaciones'){
            selected = (!!this.$route.params.status) ? this.asignacionesPorEstados[this.$route.params.status] : this.asignaciones;
          }
        }else{
          selected = (this.$route.name == 'validaciones') ? this.validaciones : this.tutoradas;
        }


        (!!!selected) ? selected = [] : null;

        return selected;
      },
      listadopracticas() {
        if (!!this.dataSelected) {

          let practicas = new Array();

          this.dataSelected.forEach(c => {
            let practica = {
              "Id práctica": c.idPractica,
              "Nombre y apellidos": c.nombreEstudiante,
              "Titulación": c.titulacion,
              "Email": c.emailEstudiante,
              "Tipo Creditos": c.tipoCreditos,
              "Puesto": c.puesto,
              "Total Horas": c.totalHoras,
              "Horas al Día": c.horasDia,
              "Nº Dias Semana": c.numDiasSemana,
              "Nombre de empresa": c.nombreEmpresa,
              "Sector de la empresa": c.sectorEmpresa,
            }

            practicas.push(practica);
          });


          return practicas;

        }
      },
    },
    components :{
      'column-setter' : columnSetter,
      'next' : next,
      'fav' : fav,
      'columnas' : columnas,
      'excel' : excel
    },
    data() {
      return {
        showColumnasSetter : false,
        selected : {},
        encabezados : {},
        columns: [],
        options : {
         skin: 'table',
         highlightMatches : true,
         headings : {},
         texts: {
          filter: "Buscar:",
          filterBy: 'Filtrar por {column}',
          count:'',
          records : 'Resultados',
          limit : "Por Página: ",
          page : "Págína:",
          noResults:"No se han encontrado resultados",
          filterPlaceholder:"Escribe para buscar",
        },
        dateFormat: 'DD-MM-YY',
        perPage:100,
        resizableColumns : true,
        perPageValues : [10,20,30,50],
        columnsClasses : {},
        sortIcon:{
          is:'glyphicon-sort',
          base:'glyphicon',
          up: 'fa fa-angle-up',
          down: 'fa fa-angle-down'
        },
        rowClassCallback(row,$route) {
          let lastParam = window.location.pathname.split("/").pop();
          return (row.idPractica == lastParam) ? 'selected' : '';
        }
      },
      tableData: [],

    }
  },

}
</script>

<style scoped lang="scss">

  .ficha-title{
    margin-top: 0;
    margin-bottom: 0;
    width: auto;
  }

  .toggle-todo{
    position: absolute;
    left: 10px;
    top: 47px;
    width: 15px;
    height: 15px;
    line-height: 15px;
    background: #d8d8d8;
    font-size: 12px;
    color: #4a4a4a;
  }

  .contenedor-tabla {
    width: 100%;
    min-height: 100%;
    display: inline-block;
  }
  
  .contenedor-opciones{
    width: 100%;
    padding-bottom: 20px;
    position: relative;
  }

  .option-table{
    text-transform: uppercase;
    font-size: 9px;
    text-align: center;
    padding: 0 10px;
    position: relative;
  }

  .column{
    width: 30px;
    height: 30px;
    position: relative;
    margin-bottom: 10px;

    svg{
      width: 40px;
    }
  }

  .to-ficha{
    width: 10px;
    height: 20px;
    display: inline-block;
    font-size: 0;
    svg{
      width: 10px;
      height: 20px;
    }
  }


  .checkbox-cell{
    min-width: 65px;
  }




</style>



// WEBPACK FOOTER //
// src/components/views/contenedor-tabla.vue